import { useCallback, useEffect, useRef } from 'react'

export const useCloseOnClickOutside = (onClose) => {
  const actionRef = useRef()
  const containerRef = useRef()
  const timeoutRef = useRef()

  const captureListener = useCallback((event) => {
    if (!(event.target instanceof Node && (
      containerRef.current?.isSameNode(event.target)
    ))) {
      return
    }

    actionRef.current = () => onClose()
    timeoutRef.current = setTimeout(() => {
      if (actionRef.current) {
        actionRef.current()
        actionRef.current = undefined
      }
    }, 0)
  }, [actionRef, containerRef, onClose, timeoutRef])

  useEffect(() => {
    document.addEventListener('click', captureListener, true)

    return () => {
      document.removeEventListener('click', captureListener, true)
    }
  }, [captureListener])

  useEffect(() => () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current)
    }
  }, [timeoutRef])

  return { containerRef }
}
